export default {
    guider: {
        title: '您当前是否想获得这些帮助：',
        more: '来帮助中心，发现更多提效技能',
    },
};
